import React from 'react';
import './SubcategoryArrow.css';

export const SubcategoryArrow = ({
    arrowPosition,
    clickHandler,
}) => {
    return (
        <div
            className={`asg-subcategories__arrow asg-subcategories__arrow--${arrowPosition}`}
        >
            <div className="asg-subcategories__arrow-btn-circle">
                <div className="asg-subcategories__arrow-btn" onClick={clickHandler} />
            </div>
            <div className="asg-subcategories__arrow-shadow" />
        </div>
    );
};
